import { ColumnsStrategy } from "@/common/types";
import DefaultHeadColumns from "../../../components/TableComponents/Head/DefaultHeadColumns";
import {
  DefaultTextColumn,
  FilterSelect,
  OptionsCell,
  TableCellWithTime,
} from "@/components/TableComponents";
import dayjs from "dayjs";
import quotesRender from "@/common/const/elementsList/quotesRender.const";
import AIRXQuoteActions from "@/components/Quotes/AIRXQuoteTable/AIRXQuoteActions";
import RangeFilter from "@/components/TableComponents/Head/RangeFilter";
import { quoteStatuses } from "@/common/const/quote/quoteStatuses.const";
import AIRXQuoteStatusCell from "@/components/TableComponents/Cells/AIRXQuoteStatusCell";
import SortComponent from "@/components/TableComponents/Head/SortComponent";
import currencyOptions from "@/common/const/filter-options/currencyTypes.options";
import { contractTermsOptions } from "@/common/const/types/index.const";

const airxVendorViewStrategy: ColumnsStrategy[] = [
  {
    label: <DefaultHeadColumns text={"ACTIONS"} key="head-ACTIONS" />,
    name: "actions",
    key: "col-ACTIONS",
    render: (_: number, record: any) => {
      return (
        <AIRXQuoteActions
          quoteLine={record}
          source="vendor"
          key={`action-${record.id}`}
        />
      );
    },
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
  },
  {
    label: <DefaultHeadColumns text="QUOTE LINE ID" key="head-QUOTE_LINE_ID" />,
    name: "id",
    key: "col-QUOTE_LINE_ID",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: number) => {
      return (
        <DefaultTextColumn
          text={value?.toString()}
          key={`quoteLineId-${value}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Quote Id" key="head-Quote_Id" />,
    name: "quote",
    key: "col-Quote_Id",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.id.toString()}
          key={`quoteId-${record.id}-${record.quoteReqId}-${value?.id}`}
        />
      );
    },
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-status"
        values={quoteStatuses}
        key="head-quote_product_filter"
      />
    ),
    name: "quote",
    key: "col-quote_status",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <AIRXQuoteStatusCell
          permission="quotes_vendor_edit"
          quoteId={value?.id}
          value={value?.status}
          key={`quoteStatus-${record.id}-${value?.id}-${record.quoteReqId}-${value?.status}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="CUSTOMER NAME" key="head-CUSTOMER_NAME" />,
    name: "quote",
    key: "col-CUSTOMER_NAME",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.initiator.companyName}
          key={`customerName-${value?.initiator.companyName}-${record.id}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="VENDOR NAME" key="head-VENDOR_NAME" />,
    name: "quote",
    key: "col-VENDOR_NAME",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.implementer.companyName}
          key={`vendorName-${value?.implementer.companyName}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <DefaultHeadColumns
        text="LAST MILE PROVIDER"
        key="head-LAST_MILE_PROVIDER"
      />
    ),
    name: "price",
    key: "col-LAST_MILE_PROVIDER",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.lastMileProvider}
          key={`lastMileProvider-${value?.lastMileProvider}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <DefaultHeadColumns
        text="End Customer Name"
        key="head-End_Customer_Name"
      />
    ),
    name: "quote",
    key: "col-End_Customer_Name",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.endCustomerName}
          key={`endCustomerName-${value?.endCustomerName}-${record.id}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Address" key="head-Address" />,
    name: "quote",
    key: "col-Address",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.addressA.locationId}
          className="capitalize"
          key={`address-${value?.addressA.locationId}-${record.id}`}
          labelClassName="capitalize"
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Country" key="head-Country" />,
    name: "quote",
    key: "col-Country",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.addressA.country}
          key={`country-${value?.addressA.country}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-type"
        values={quotesRender}
        key="head-quote_product_filter"
      />
    ),
    name: "quote",
    key: "col-quote_type",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <OptionsCell
          value={value?.type}
          options={quotesRender}
          key={`quoteType-${value?.type}-${value?.id}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <SortComponent
        childKey={"createdAt"}
        title={"Quote Date"}
        tooltipVariants={["From Newest to Oldest", "From Oldest to Newest"]}
      />
    ),
    name: "quote",
    key: "col-Quote_Date",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <TableCellWithTime
          value={value?.createdAt}
          format="DD.MM.YYYY"
          key={`quoteDate-${value?.createdAt}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <SortComponent
        childKey={"createdAt"}
        title={"Expiration Date"}
        tooltipVariants={["From Newest to Oldest", "From Oldest to Newest"]}
      />
    ),
    name: "quote",
    key: "col-Expiration_Date",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <TableCellWithTime
          value={dayjs(value?.createdAt).add(90, "d") as unknown as string}
          format="DD.MM.YYYY"
          key={`expirationDate-${value?.createdAt}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <FilterSelect
        values={[...currencyOptions]}
        fieldName="filters-currency"
        key="head-Currency"
      />
    ),
    name: "price",
    key: "col-Currency",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <OptionsCell
          options={currencyOptions}
          value={value?.currency}
          key={`currency-${value?.currency}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-OTE"
        title="OTE"
        max={100000}
        min={0}
        key="head-TOTAL_OTC"
      />
    ),
    name: "price",
    key: "col-TOTAL_OTC",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          text={value?.OTE ? value?.OTE : "0"}
          key={`totalOTC-${value?.OTE}-${value?.OTE}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-MRE"
        title="MRE"
        max={100000}
        min={0}
        key="head-TOTAL_MRC"
      />
    ),
    name: "price",
    key: "col-TOTAL_MRC",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          text={value?.MRE ? value?.MRE : "0"}
          key={`totalOTC-${value?.MRE}-${value?.MRE}-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <DefaultHeadColumns
        text="Total Contractual Expenses"
        key="head-total_Contractual_Expenses"
      />
    ),
    name: "price",
    key: "col-total_Contractual_Expenses",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          className="text-primary"
          text={
            value?.MRE && value?.OTE && value?.contractTerm
              ? value?.contractTerm * value?.MRE + value?.OTE
              : "0"
          }
          key={`total-contractual-expenses-${record.id}`}
        />
      );
    },
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-contractTerm"
        values={[...contractTermsOptions]}
        key="head-Contract_Terms"
      />
    ),
    name: "price",
    key: "col-Contract_Terms",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          text={value?.contractTerm}
          key={`contractTerms-${value?.contractTerm}-${value?.id}-${record.id}`}
        />
      );
    },
  },
];

export default airxVendorViewStrategy;
